import React, { useEffect } from "react";
import PropTypes from "prop-types";
import FilterButtonComponent from "./FilterButtonComponent";
import ResetButtonComponent from "./ResetButtonComponent";
import { updateURLQuery } from "../../utils/updateURLQuery";

const FilterBodyComponent = ({ children, handleFilter, handleRestFilter, formState }) => {
    useEffect(() => {
        updateURLQuery(formState);
    }, [formState]);
    const handleRest = (e) => {
        e.preventDefault()
        handleRestFilter(e)
    }
    return (
        <div className="filter-body py-4 rounded-lg shadow-lg">
            <div className="row custom-row">
                {children}
            </div>
            <div className="row mt-4 justify-content-end">
                <div className="col-6 text-end">
                    <FilterButtonComponent onClick={handleFilter} />
                    <ResetButtonComponent onClick={handleRest} />
                </div>
            </div>
        </div>
    );
};

FilterBodyComponent.propTypes = {
    children: PropTypes.node.isRequired,
};

export default React.memo(FilterBodyComponent);
